import { RegionCode } from '@aviv-estimation-funnel/estimation-data-models/enums';
import { z } from 'zod';

import { UnableToParseValue } from '../exceptions';
import { FieldValidator } from '../field-validator';
import { AcceptedCountryCodePhoneNumberFilter } from '../filters/phone-number/accepted-country-code-phone-number-filter';
import { MobilePhoneNumberFilter } from '../filters/phone-number/mobile-phone-number-filter';
import { ValidPhoneNumberFilter } from '../filters/phone-number/valid-phone-number-filter';
import { PhoneNumber } from '../phone-number';
import { FieldValues } from '../types';

export class PhoneNumberValidator extends FieldValidator<PhoneNumber> {
    constructor(public readonly selectedRegionCodeFieldName: string) {
        super('phoneNumber');
        this.filters.push(new ValidPhoneNumberFilter());
    }

    override parse(fieldValue: unknown, allFields: FieldValues): PhoneNumber | undefined {
        try {
            const phoneNumberRaw = z.string().optional().parse(fieldValue);
            if (phoneNumberRaw === undefined) {
                return undefined;
            }

            const expectedRegionCode: RegionCode = allFields[
                this.selectedRegionCodeFieldName
            ] as RegionCode;

            if (expectedRegionCode === undefined) {
                return undefined;
            }

            return new PhoneNumber(phoneNumberRaw, expectedRegionCode);
        } catch (zodErrors: any) {
            throw new UnableToParseValue(fieldValue);
        }
    }

    regionCodeIn(acceptedRegionCodes: Array<RegionCode>): this {
        this.filters.push(new AcceptedCountryCodePhoneNumberFilter(acceptedRegionCodes));
        return this;
    }

    mobile(): this {
        this.filters.push(new MobilePhoneNumberFilter());
        return this;
    }
}
